import * as React from "react";
import Component from "../../AbstractComponent";
import { connect } from "react-redux";
import TypeContainer from "../../../Entity/Entities/Charge/Type/TypeContainer";
import PeriodContainer from "../../../Entity/Entities/Charge/Period/PeriodContainer";
import { ChargeTypeCreate } from "../../Partials/Dialog/ChargeTypeCreate";
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";
import Select from "../../Partials/Material/Select";
import MenuItem from '@material-ui/core/MenuItem';
import TextField from "../../Partials/Material/TextField";
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import FormControlLabel from '@material-ui/core/FormControlLabel';
// import Checkbox from '@material-ui/core/Checkbox';
import { DatePickerComponent } from "../../Partials/DatePicker/DatePickerComponent";
import ChargeTemplateUpdateWillMount from "../../../Middleware/Middlewares/ChargeTemplateUpdateWillMount";
import { MiddlewareInterface } from "../../../Middleware/MiddlewareInterface";
import Formatter from "../../../Localization/Formatter";
import Constants from "../../../Action/Constants";
import { FirstDayOfPeriod } from "../../../Entity/Entities/Charge/PaymentOffset/Offsets/FirstDayOfPeriod";
import { PersonInterface } from "../../../Entity/Entities/Person/PersonInterface";
import { CompanyInterface } from "../../../Entity/Entities/Company/CompanyInterface";
import Switch from '@material-ui/core/Switch';
import { CoachNewCounterpartyDialog } from "../../Partials/Dialog/CoachNewCounterpartyDialog";
import Searchbar from "../Searchbar/Searchbar";
import { Company } from "../../../Entity/Entities/Company/Company";
import { Person } from "../../../Entity/Entities/Person/Person";
import ChargeClassContainer from "../../../Entity/Entities/Charge/ChargeClass/ChargeClassContainer";

export class ChargeTemplateUpdate extends Component {
  protected middlewares: MiddlewareInterface[] = [
    ChargeTemplateUpdateWillMount
  ];

  public state = {
    chargeTemplate: null,
    isDefault: this.props.isDefault,
    amount: "",
    currency: this.props.app.settings.user.currency.getCurrencyId(),
    repeatPeriod: this.props.selectedType === TypeContainer.pickIdFromLabel("Deposit") ? PeriodContainer.pickIdFromLabel("once") : PeriodContainer.pickIdFromLabel("monthly"),
    description: this.props.description ? this.props.description : "",
    paymentOffset: FirstDayOfPeriod.value,
    type: this.props.selectedType ? this.props.selectedType : TypeContainer.pickIdFromLabel("Other_receivable"),
    dueDateFirstPayment: this.props.firstDate ? this.props.firstDate : null,
    dueDateFirstPaymentWasManuallyChanged: false,
    firstDate: this.props.firstDate ? this.props.firstDate : null,
    endDate: this.props.endDate ? this.props.endDate : null,
    isCreateChargeTypePopupOpen: false,
    isPaidDirectlyToOwner: false,
    isForContract: this.props.entity === "contract",
    isForUnit: this.props.entity === "unit",
    isForProperty: this.props.entity === "property",
    error: "",
    selectedCounterparty: null,
    isEndChargeTemplateDialogOpen: false,
    isCollective: typeof this.props.isCollective !== "undefined" ? this.props.isCollective :
      (this.props.entity === "contract" || this.props.isDefault) && this.props.selectedType !== TypeContainer.pickIdFromLabel("Deposit") ? true : false,
    openCoachCreateNewCounterparty: false
  };

  constructor(public props) {
    super(props);
  }

  public selectDate = (momentDate: any, identifier: string): any => {
    const date = !!momentDate && typeof momentDate.toDate === "function" ? momentDate.toDate() : momentDate;

    this.setState({
      [identifier]: date,
      hasModifiedData: true
    }, () => {
      if (!this.state.isForContract && !this.state.isDefault && identifier === "firstDate") {
        this.setState({
          dueDateFirstPayment: date
        })
      }
    });
  }

  public onCancel = (): any => {
    if (typeof this.props.onCancel !== "undefined") {
      this.props.onCancel.call(this);
    }
  }

  public onSave = (): any => {
    const payload: any = {
      id: this.state.chargeTemplate.id,
      amount: this.state.amount === "" ? "" : parseFloat(parseFloat(String(Formatter.deleteExtraSpace(this.state.amount)).replace(",", ".")).toFixed(2)),
      currency: this.state.currency,
      currencyId: this.state.currency,
      repeatPeriod: this.state.repeatPeriod,
      repeatPeriodId: this.state.repeatPeriod,
      type: this.state.type,
      description: this.state.description,
      paymentOffset: this.state.paymentOffset,
      dueDateFirstPayment: this.state.dueDateFirstPayment,
      firstDate: this.state.firstDate,
      endDate: this.state.endDate,
      isDefault: this.state.isDefault,
      isPaidDirectlyToOwner: this.state.isPaidDirectlyToOwner,
      error: this.state.error,
      isCollective: this.state.isCollective
    }

    if (this.state.selectedCounterparty instanceof Person) {
      payload.contactId = this.state.selectedCounterparty?.id;
      payload.companyId = null;
    }

    if (this.state.selectedCounterparty instanceof Company) {
      payload.companyId = this.state.selectedCounterparty?.id;
      payload.contactId = null;
    }

    if (this.state.isDefault) {
      payload.companyId = null;
      payload.contactId = null;
    }

    if (typeof this.props.onSave === "function") {
      this.props.onSave.call(this, { ...payload });
    }
  }

  public addChargeType = (chargeType: object, callback?): void => {
    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_CHARGE_TYPE_CREATE_START,
        payload: {
          chargeType: chargeType
        },
        onSuccess: (chargeType) => {
          this.setState({
            type: chargeType?.id,
            isCreateChargeTypePopupOpen: false,
            hasModifiedData: true,
            isSaving: false,
          });

          if (typeof callback === "function") {
            callback();
          }
        },
        onError: () => {
          this.setState({
            hasModifiedData: true,
            isSaving: false
          });
        }
      });
    });
  }

  public closeChargeTypeCreateDialog = (): void => {
    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_TYPE_CREATE_CLEAR,
    });

    this.setState({ isCreateChargeTypePopupOpen: false });
  }

  public renderDueDateField = (): any => {
    if (PeriodContainer.pickIdFromLabel("once") === this.state.repeatPeriod) {
      return (
        <DatePickerComponent
          {...this.props}
          className="scroll-to-dueDateFirstPayment"
          label={this.trans("dialog/defaultchargetemplates-field/duedatepayment-label")}
          initialDate={this.state.dueDateFirstPayment}
          onChange={date => this.selectDate(date, "dueDateFirstPayment")}
          disabled={!!this.props.disabled}
          clearButton={true}
          error={this.getErrorFor("dueDateFirstPayment")}
          height={"50px"}
        />
      );
    }

    return (
      <div>
        <DatePickerComponent
          {...this.props}
          className="scroll-to-dueDateFirstPayment"
          label={this.trans("dialog/defaultchargetemplates-field/duedatefirstpayment-label")}
          initialDate={this.state.dueDateFirstPayment}
          onChange={date => this.selectDate(date, "dueDateFirstPayment")}
          disabled={!!this.props.disabled}
          clearButton={true}
          error={this.getErrorFor("dueDateFirstPayment")}
          height={"50px"}
        />
      </div>
    );
  }

  public switchIsPaidDirectlyToOwner = () => {
    this.setState({
      isPaidDirectlyToOwner: !this.state.isPaidDirectlyToOwner
    });
  }

  public changeIsCollective = () => {
    this.setState({
      isCollective: !this.state.isCollective
    });
  }

  public selectCounterparty = (entity: CompanyInterface | PersonInterface): void => {
    this.setState({
      selectedCounterparty: entity,
      hasModifiedData: true
    });
  }

  public clearCounterparty = (): void => {
    this.setState({
      selectedCounterparty: null,
      hasModifiedData: true
    });
  }

  public render() {
    return (
      <div>
        {this.props.disabled && (
          <div style={{ color: "#00BCD4", fontSize: "14px", margin: "-5px 0 -10px 0" }}>{this.trans("page/contracts-hint/readonly")}</div>
        )}
        {this.props.showInformationText &&
          <div className="hint-styles-dialog" style={{ color: "#333", margin: "0px" }}>
            {this.trans("dialog/chargetemplate-info1")}
          </div>
        }
        {this.props.isDefault &&
          <div className="hint-styles-dialog" style={{ color: "#333", margin: "0px" }}>
            {this.trans("dialog/defaultchargetemplate-info1")}
          </div>
        }

        <div>
          <div style={{ display: "flex", justifyContent: "flex-start", marginBottom: "-10px" }}>
            <div style={{ display: "flex", flexDirection: "column", width: "50%", marginRight: "15px" }}>
              <TextField
                autoComplete="off"
                // id="amount"
                // name="amount"
                className="form-element scroll-to-amount"
                type="text"
                label={this.trans("dialog/defaultchargetemplates-field/amount-label")}
                value={this.state.amount}
                onChange={this.sync.bind(this, this.syncronizers.EVENT, "amount")}
                autoFocus={true}
                disabled={!!this.props.disabled}
                variant="standard"
                error={!!this.getErrorFor("amount")}
              />
              {!!this.getErrorFor("amount") && <div className="component-error-text">{this.getErrorFor("amount")}</div>}
            </div>

            <Select
              className="form-element full-size form-input scroll-to-currency correct-label-position"
              error={this.getErrorFor("currency")}
              style={{ width: "50%" }}
              disabled={!!this.props.disabled}
              value={this.state.currency}
              onChange={this.sync.bind(this, this.syncronizers.CURRENCY)}
              htmlFor="currency"
              label={this.trans("dialog/defaultchargetemplates-field/currency-label")}
              name="currency"
              id="currency"
            >
              {this.getCurrencySelectboxes()}
            </Select>
          </div>

          <Select
            className="form-element full-size form-input scroll-to-type correct-label-position"
            error={this.getErrorFor("type")}
            disabled={!!this.props.disabled}
            value={this.state.type}
            onChange={this.sync.bind(this, this.syncronizers.TYPE)}
            htmlFor="type"
            label={this.trans("dialog/defaultchargetemplates-field/type-label")}
            name="type"
            id="type"
          >
            {
              TypeContainer.getChargeTypesForChargeTemplates(this.props.entity).filter(chargeType => {
                if (!!this.state.type && chargeType?.removed && (chargeType?.id === this.state.type)) {
                  return true;
                }

                if (chargeType?.removed) {
                  return false;
                }

                return true;
              })
                .map((type, index) => {
                  return (
                    <MenuItem key={`chargeType-${index}`} value={type.id} disabled={(type.id === -1 || type.id === -2)}>{`${type.id === -1 || type.id === -2 ? type.label : Formatter.checkTranslationType(this.trans(type?.label, {}, "", type?.system), type?.label, type?.system)}`}</MenuItem>
                  );
                })
            }
            {/* {
            <MenuItem
              className="add-charge-type-div button-add-wrapper"
            >
              <Button
                style={{width: "100%"}}
                className="add-charge-type-button color-button-add"
                color="primary"
                onClick={() => this.setState({isCreateChargeTypePopupOpen: true})}
              >
                {this.trans("dialog/chargetype-button/newchargetype")}
              </Button>
            </MenuItem>
          } */}
          </Select>

          <Select
            className="form-element full-size form-input scroll-to-repeat-period correct-label-position"
            error={this.getErrorFor("repeat-period")}
            disabled={!!this.props.disabled}
            value={this.state.repeatPeriod}
            onChange={this.sync.bind(this, this.syncronizers.REPEAT_PERIOD)}
            htmlFor="repeatPeriod"
            label={this.trans("dialog/defaultchargetemplates-field/period-label")}
            name="repeatPeriod"
            id="repeatPeriod"
          >
            {this.getRepeatPeriodSelectboxes()}
          </Select>

          {
            this.state.isForContract && (
              <Select
                className="form-element full-size form-input scroll-to-payment-offset correct-label-position"
                error={this.getErrorFor("payment-offset")}
                disabled={!!this.props.disabled}
                value={this.state.paymentOffset}
                onChange={this.sync.bind(this, this.syncronizers.PAYMENT_OFFSET)}
                htmlFor="paymentOffset"
                label={this.trans("dialog/defaultchargetemplates-field/paymentoffset-label")}
                name="paymentOffset"
                id="paymentOffset"
              >
                {this.getPaymentOffsetSelectboxes()}
              </Select>
            )
          }

          {
            !this.state.isDefault && (
              <div className="search-bar-container" style={{ margin: "-20px 0 -10px 0" }}>
                <Searchbar
                  {...this.props}
                  id="selectedCounterparty"
                  className={"scroll-to-counterpartyId"}
                  height={400}
                  // floatingLabelText={labelText}
                  floatingLabelText={TypeContainer.pickChargeClassIdFromId(this.state.type) === ChargeClassContainer.pickIdFromLabel("Receivable") ? this.trans("section/charge-field/from-label") : this.trans("section/charge-field/to-label")}
                  allResults={true}
                  objectField={true}
                  onChange={this.selectCounterparty}
                  onClear={this.clearCounterparty}
                  selectedEntity={this.state.selectedCounterparty}
                  searchParameter={"contactsSearch"}
                  error={this.getErrorFor("counterpartyId")}
                  disabled={!!this.props.disabled}
                  searchText={this.state.selectedCounterparty ? `${this.state.selectedCounterparty?.nameOfEntity}, ${this.state.selectedCounterparty?.displayName}` : null}
                  styleInModal={"pick-object-modal"}
                  createButton={"dropdown-button/newcounterparty"}
                  openCoachCreateNewEntity={() => {
                    this.setState({
                      openCoachCreateNewCounterparty: true,
                      selectedCounterparty: null
                    })
                  }
                  }
                />
              </div>
            )
          }

          {this.state.isForContract && this.renderDueDateField()}

          {!this.state.isDefault && !this.state.isForContract && (
            <DatePickerComponent
              {...this.props}
              className="scroll-to-firstDate"
              label={this.trans("dialog/defaultchargetemplates-field/firstdate-label")}
              initialDate={this.state.firstDate}
              onChange={date => this.selectDate(date, "firstDate")}
              clearButton={true}
              error={this.getErrorFor("firstDate")}
              height={"50px"}
            />
          )}

          {!this.state.isDefault && !this.state.isForContract && (
            <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "baseline" }}>
              <DatePickerComponent
                {...this.props}
                id="endDate"
                name="endDate"
                className="scroll-to-endDate"
                label={this.state.endDate ? this.trans("label/end-date") + this.trans("field/optional") : this.trans("end-date-not-set") + this.trans("field/optional")}
                initialDate={this.state.endDate}
                clearButton={true}
                minDate={this.state.firstDate}
                minDatePlusDays={1}
                disabled={true}
                error={this.getErrorFor("endDate")}
                width={"50%"}
              />

              {
                this.state.endDate && (
                  <Button
                    color="primary"
                    onClick={() => {
                      if (this.checkProcessIsBusy({
                        action: "end",
                        entityName: "chargeTemplate",
                        entity: this.state.chargeTemplate
                      })) {
                        this.openIsBusyPopup();
                      } else {
                        this.selectDate(null, "endDate");
                      }
                    }}
                    style={{ marginLeft: "20px", color: "#00BCD4", border: "1px solid rgba(0, 0, 0, 0.1)" }}
                    disabled={!!this.props.disabled}
                  >
                    {this.trans("clear-end-date")}
                  </Button>
                )
              }

              {
                !this.state.endDate && (
                  <Button
                    color="primary"
                    onClick={() => {
                      if (this.checkProcessIsBusy({
                        action: "end",
                        entityName: "chargeTemplate",
                        entity: this.state.chargeTemplate
                      })) {
                        this.openIsBusyPopup();
                      } else {
                        this.setState({ isEndChargeTemplateDialogOpen: true })
                      }
                    }}
                    style={{ marginLeft: "20px", color: "#00BCD4", border: "1px solid rgba(0, 0, 0, 0.1)" }}
                    disabled={!!this.props.disabled}
                  >
                    {this.trans("set-end-date")}
                  </Button>
                )
              }
            </div>
          )}

          <TextField
            autoComplete="off"
            className="form-element full-size scroll-to-description"
            type="text"
            label={this.trans("dialog/defaultchargetemplates-field/description-label")}
            value={this.state.description}
            onChange={this.sync.bind(this, this.syncronizers.EVENT, "description")}
            disabled={!!this.props.disabled}
            variant="standard"
            error={!!this.getErrorFor("description")}
          />
          {!!this.getErrorFor("description") && <div className="component-error-text">{this.getErrorFor("description")}</div>}

          {/* {
          (this.state.isForContract || this.state.isDefault) &&
            <FormControlLabel
              control={
                <Checkbox
                  checked={this.state.isPaidDirectlyToOwner}
                  onChange={this.switchIsPaidDirectlyToOwner}
                  color="primary"
                />
              }
              label={this.trans("dialog/defaultchargetemplates-field/paiddirectlytoowner-label")}
          />
        } */}

          {
            this.state.isForContract && (
              <div>
                <FormControlLabel
                  control={
                    <Switch
                      checked={!this.state.isCollective}
                      onChange={this.changeIsCollective}
                      color="primary"
                    // disabled={!!this.props.disabled}
                    />
                  }
                  label={this.trans("dialog/defaultchargetemplates-label/collate")}
                />
              </div>
            )
          }
        </div>

        <DialogActions>
          <div className="button-container">
            <Button
              color="primary"
              onClick={this.onCancel}
            >
              {this.trans("dialog-button/cancel")}
            </Button>

            <Button
              variant="contained"
              color="primary"
              onClick={this.onSave}
              disabled={this.props.chargeTemplateUpdate && this.props.chargeTemplateUpdate.isFetching === true}
            >
              {this.props.chargeTemplateUpdate && this.props.chargeTemplateUpdate.isFetching === true ?
                this.trans("dialog-button/saving") : this.trans("dialog-button/save")}
            </Button>
          </div>
        </DialogActions>

        <PromptDialog
          {...this.props}
          title={this.trans("dialog/chargetype-title")}
          content={
            <ChargeTypeCreate
              {...this.props}
              onSaveType={this.addChargeType}
              onCancelType={this.closeChargeTypeCreateDialog}
              onClose={this.closeChargeTypeCreateDialog}
            />
          }
          openLeavePrompt={this.state.isCreateChargeTypePopupOpen}
          withoutDefaultDilaogButtons={true}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("end-charge-template-modal-title")}
          content={(
            <div>
              <p>{this.trans("dialog/preprocess-endchargetemplate-info1")}</p>
              <div style={{ width: "50%" }}>
                <DatePickerComponent
                  {...this.props}
                  label={this.state.endDate ?
                    this.trans("end-date") : this.trans("label-click-set-the-end-date")}
                  initialDate={this.state.endDate ? this.state.endDate : null}
                  onChange={date => this.selectDate(date, "endDate")}
                  clearButton={true}
                  error={this.getErrorFor("endDate")}
                />
              </div>
              <p>{this.trans("dialog/preprocess-endchargetemplate-info2")}</p>
            </div>
          )}
          negativeButtonLabel={this.trans("button-cancel")}
          positiveButtonLabel={this.trans("set-end-date")}
          positiveButtonStyle={{ backgroundColor: "red" }}
          openLeavePrompt={this.state.isEndChargeTemplateDialogOpen}
          onDiscard={() => {
            this.selectDate(this.state.chargeTemplate?.endDate, "endDate");
            this.setState({ isEndChargeTemplateDialogOpen: false });
          }}
          onSave={() => this.setState({ isEndChargeTemplateDialogOpen: false })}
          hideCross={true}
        />

        <CoachNewCounterpartyDialog
          {...this.props}
          openCoachCreateNewCounterparty={this.state.openCoachCreateNewCounterparty}
          onCloseCounterpartyCoach={entity => {
            if (entity) {
              this.setState({
                openCoachCreateNewCounterparty: false
              }, () => { this.selectCounterparty(entity) })
            } else {
              this.setState({
                openCoachCreateNewCounterparty: false
              })
            }
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    globalTypes: state.globalTypes,
    component: state.chargeTemplateUpdate
  };
};

export default connect(mapStateToProps)(
  ChargeTemplateUpdate
);
